import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/analytics';
import apiKey from './api-Key';

const firebaseConfig = {
  apiKey: apiKey,
  authDomain: "thefinalhomecare.firebaseapp.com",
  databaseURL: "https://thefinalhomecare.firebaseio.com",
  projectId: "thefinalhomecare",
  storageBucket: "thefinalhomecare.appspot.com",
  messagingSenderId: "291820958373",
  appId: "1:291820958373:web:be8234ec9e2226811b134c",
  measurementId: "G-9RB9JQH018"
};


firebase.initializeApp(firebaseConfig);
// Pulling the entire database at the same time.
// var db = firebase.database().ref();

export const dbFamMember = firebase.database().ref().child('familyMembers');
export const dbCaregivers = firebase.database().ref().child('caregivers');
export const dbTasks = firebase.database().ref().child('tasks');
export const dbSeniors = firebase.database().ref().child('seniors');
export const dbFamtoFam = firebase.database().ref().child('famtofam');
export const dbPending=firebase.database().ref().child('pending');
export const dbClicks=firebase.database().ref().child('clicks');
export const dbEmails=firebase.database().ref().child('emails');
export const dbArticles=firebase.database().ref().child('articles');
export const dbAgency=firebase.database().ref().child('Agency');
export const dbContactUs=firebase.database().ref().child('ContactUs');

export const logObject = firebase.analytics();




